
import { showVuePopup } from '../../utils/showVuePopup';
import AffiliateLink from '../../popup/AffiliateLink.vue';
import AffiliateTransaction from '../../popup/AffiliateTransaction.vue';
import AffiliateReport from '../../popup/AffiliateReport.vue';
import AffiliateDownline from '../../popup/AffiliateDownline.vue';
import { useSession } from '../../stores/session';

export default {
	name: 'PopupAffiliateNavbar',
	setup() {

		const session = useSession();

		const btnClickAffiliateLink = async () => {
			session.set('navbar_sub', 'affiliate:detail');
			await showVuePopup(AffiliateLink);
		}

		const btnClickAffiliateHistory = async () => {
			session.set('navbar_sub', 'affiliate:transaction');
			await showVuePopup(AffiliateTransaction);
		}

		const btnClickAffiliateReport = async () => {
			session.set('navbar_sub', 'affiliate:report');
			await showVuePopup(AffiliateReport);
		}

		const btnClickAffiliateDownline = async () => {
			session.set('navbar_sub', 'affiliate:downline');
			await showVuePopup(AffiliateDownline);
		}

		return {
			session,
			btnClickAffiliateLink,
			btnClickAffiliateHistory,
			btnClickAffiliateReport,
			btnClickAffiliateDownline,
		}
	}
}
